import * as React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { items } from '../../constants/content';
import { URLs } from '../../constants/urls';
import Search from '../search/search';
import GenericButton from '../shared/genericButton/genericButton';
import Tile from '../tile/tile';
import './HelpSupportItems.css';

export interface IHelpSupportItemsProps {
    history: any;
}

class HelpSupportItems extends React.Component<IHelpSupportItemsProps> {
    constructor(props: IHelpSupportItemsProps) {
        super(props);
        this.state = {  };
    }
    
  public  render() {
        return <Col xs="12">
            {true && <Row>
                <Col xs={{ size: 10, offset: 1 }} className="tile-container">
                    <Search />
                    <Row>
                        <>
                        <Col xs={{size: 12, offset: 0}}>
            <div className="helptitle">
            <Row>
                <Col xs={{size: 9, offset: 0}}>                        
                            <h2>What's new</h2>
                            <h3>We've made some changes to Gem Connect</h3>
                            </Col>
                            <Col xs={{size: 3, offset: 0}} className="helpcol">
                            <Link to={URLs.whatsNew}>                        
                            <GenericButton
                         isOnBackground={true}
                         name={"Find out more"}
                         variant="secondary"
                         type="button"
                         iconClassNameRight="fa fa-angle-right fa-x2"
                         className="float-left marginRight10 primaryButton whatsnewbtn"
                         id="secondaryButton"
                         
                         />
                         </Link>
                         </Col>
                         </Row>
                        </div>
                        </Col>
                        {items.map(item => {
                            return (<Tile key={item.id} iconName={item.iconName} caption={item.caption} onClick={this.selectItem} item={item} />)
                            
                        })}
                        </>
                    </Row>
                </Col>
            </Row>}
        </Col>
    }
private selectItem = (item: any)=> {
        this.props.history.push(URLs.itemDetails.replace(':subItemIds', item.id));
    }
}
 
export default HelpSupportItems;


// WEBPACK FOOTER //
// ./src/components/helpSupportItems/HelpSupportItems.tsx